/** Compact copy for the pilot info alert — same structure as trading hours pilot messaging. */
export const SIDEBAR_NAVIGATION_PILOT_SHORT =
  'You are in the navigation pilot group. Your feedback helps us refine the new navigation experience before wider rollout.'

/** Longer copy for tooltips / assistive context. */
export const SIDEBAR_NAVIGATION_PILOT_BODY =
  'You are in the navigation pilot group. Your feedback helps us refine the new navigation experience before wider rollout. Switching between classic and new is not available during this phase.'
